import ApiServer from "../fizapilib.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as Storage from "../../lib/Storage.ts"
import * as Html from "../../util/Html.ts"

const closedById = JSON.parse(Storage.localGet('categoryState')||"{}")

Html.register({
  tooglecategory(){
    const 
      metaId = this.metaId(),
      open = closedById[metaId]===false;
  
    this.parent().toggleClass('fw-open',open)
    closedById[metaId] = open;
    Storage.localSet('categoryState',JSON.stringify(closedById))
  }
})

Object.assign(ApiServer.types.TaskCategoryBean.prototype,{
  onDecode(){
    FwDatas.cache(this);
    if(this.emoji===undefined){
      this.emoji = '🏷️'
    }
    this.isOpen = ()=>{
      return closedById[this.metaId]!==false;
    }
  },
  
})
